import Vue from 'vue'
import API from '@/api.js'
import {
	Message
} from 'element-ui'

//新的集成上传逻辑


export async function LayerType() {
	let list = [{
			value: 1,
			label: "严格按序"
		},
		{
			value: 2,
			label: "顺序包含"
		},
		{
			value: 3,
			label: "仅方法比对"
		},
		{
			value: 4,
			label: "方法最后值比对"
		},
		{
			value: 5,
			label: "属性一致"
		},
		// {
		// 	value: 6,
		// 	label: "方法最后结果"
		// },
	]

	return list
}
//模型标准题库图片密钥
export async function foModelQuestion(modelId) {
	
	try {
		const res = await API.get(API.fileurl.getModelQuestion, {
			orgId: localStorage.getItem('orgId') || '',
			modelId: modelId,
			userType: localStorage.getItem('userType'),
			userId: localStorage.getItem('userId')
		})
		return res.data
	} catch (err) {
		console.error('获取上传凭证失败：', err)
		Message.error('获取上传参数失败')
		throw err
	}
}
//标准模型题库图片上传oss
export async function uploadModelToOss(file, ossData,ext) {
	if (!file || !ossData) throw new Error('file / ossData 不能为空')
	if (!ossData.host || !ossData.dir || !ossData.uuid) throw new Error('OSS 参数缺失')
	// 处理路径
	const host = ossData.host.replace(/\/$/, '')
	const dir = ossData.dir.replace(/^\//, '').replace(/\/$/, '') + '/'
	
	// uuid后面追加时间戳 Date.now()
	const timestamp = Date.now()
	const key = `${dir}${ossData.uuid}_${timestamp}.${ext}`
	const formData = new FormData()
	formData.append('key', key)
	formData.append('OSSAccessKeyId', ossData.accessKeyId)
	formData.append('policy', ossData.policy)
	formData.append('signature', ossData.signature)
	formData.append('file', file)
	try {
		const controller = new AbortController()
		const timer = setTimeout(() => controller.abort(), 30000)
		const res = await fetch(host, {
			method: 'POST',
			body: formData,
			signal: controller.signal
		})
		clearTimeout(timer)
		if (res.status === 200 || res.status === 204) {
			return key
		}
		const errMsg = await res.text()
		console.error('❌ OSS 报错：', res.status, errMsg)
		throw new Error(`上传失败 ${res.status}`)
	} catch (err) {
		console.error('❌ 上传异常：', err)
		const msg = err.name === 'AbortError' ? '上传超时' : err.message
		throw new Error('上传失败：' + msg)
	}
}


/**
 * 1. 获取后端 OSS 上传凭证
 */
export async function getUploadParam(courseClassId, studentId, Type) {
	let type = Type
	try {
		const res = await API.get(API.fileurl.getUploadParam, {
			type: type,
			schoolId: localStorage.getItem('orgId') || '',
			courseClassId: courseClassId || '',
			studentId: studentId || '',
			userId: localStorage.getItem('userId')
		})
		return res.data
	} catch (err) {
		console.error('获取上传凭证失败：', err)
		Message.error('获取上传参数失败')
		throw err
	}
}

/**
 * 2. 直传阿里云OSS
 */
export async function uploadToOss(file, ossData, src) {
	console.log('1file', file)
	if (!file || !ossData) throw new Error('file / ossData 不能为空')
	if (!ossData.host || !ossData.dir || !ossData.uuid) throw new Error('OSS 参数缺失')

	// 处理路径
	const host = ossData.host.replace(/\/$/, '')
	const dir = ossData.dir.replace(/^\//, '').replace(/\/$/, '') + '/'
	const ext = file.name.split('.').pop().toLowerCase() || 'png'
	const key = `${dir}${ossData.uuid}.${ext}`

	const formData = new FormData()
	formData.append('key', key)
	formData.append('OSSAccessKeyId', ossData.accessKeyId)
	formData.append('policy', ossData.policy)
	formData.append('signature', ossData.signature)
	formData.append('file', file)

	try {
		const controller = new AbortController()
		const timer = setTimeout(() => controller.abort(), 30000)

		const res = await fetch(host, {
			method: 'POST',
			body: formData,
			signal: controller.signal
		})

		clearTimeout(timer)

		if (res.status === 200 || res.status === 204) {

			let url = `${host}/${key}`
			if (src) {
				url = key
			}
			console.log('✅ 上传成功：', url)
			return url
		}

		const errMsg = await res.text()
		console.error('❌ OSS 报错：', res.status, errMsg)
		throw new Error(`上传失败 ${res.status}`)
	} catch (err) {
		console.error('❌ 上传异常：', err)
		const msg = err.name === 'AbortError' ? '上传超时' : err.message
		throw new Error('上传失败：' + msg)
	}
}

/**
 * 3. 上传完成回调（回写数据库）
 */
export async function uploadFileCallback(file, realUrl, ossData, courseClassId, studentId, imgType, imgTypeName) {
	try {
		let messageList = [{
			"content": realUrl,
			"fileType": "img",
			"imgType": imgType,
			"imgTypeName": imgTypeName,
			"likeCount": 0,
			"fileSize": file.size
		}]

		// ✅ 接收后端返回结果（包含 id）
		const res = await API.post(API.school.postChat, {
			schoolId: localStorage.getItem('orgId'),
			courseClassId: courseClassId,
			studentId: studentId,
			source: 2,
			role: "student",
			imgType: imgType,
			messageList: messageList
		})

		// ✅ 成功时把后端数据返回出去

		if (res.data.code === 200) {
			return res.data // 这里返回 { id, fileId, code... }
		} else {
			Message.error('保存记录失败')
			throw new Error('保存失败')
		}
	} catch (err) {
		console.error('回调失败：', err)
		Message.error('保存记录失败')
		throw err
	}
}

/**
 * 4. 完整流程：获取凭证 → 上传 → 回调  最新的逻辑
 */
export async function fullUploadImage(file, courseClassId, studentId, imgType, Type, imgTypeName) {
	const ossData = await getUploadParam(courseClassId, studentId, Type)
	console.log('ossData', ossData)
	const realUrl = await uploadToOss(file, ossData, '地址')
	console.log('realUrl', realUrl)
	var id = ''
	if (imgType != 'adminIcon' && imgType != 0) {
		const isCallback = await uploadFileCallback(file, realUrl, ossData, courseClassId, studentId, imgType,
			imgTypeName)

		if (isCallback && isCallback.data) {
			id = isCallback.data
		}
	}

	return {
		url: realUrl,
		id: id
	}
}

// 本地图片转 base64（用于预览）
export function fileToBase64(file) {
	return new Promise((resolve) => {
		const reader = new FileReader()
		reader.onload = (e) => resolve(e.target.result)
		reader.readAsDataURL(file)
	})
}

// 工具：base64 → File 对象（和手动上传一样格式）
function dataURLToFile(dataurl, filename = "icon.png") {
	let arr = dataurl.split(',')
	let mime = arr[0].match(/:(.*?);/)[1]
	let bstr = atob(arr[1])
	let n = bstr.length
	let u8arr = new Uint8Array(n)
	while (n--) {
		u8arr[n] = bstr.charCodeAt(n)
	}
	return new File([u8arr], filename, {
		type: mime
	})
}

// 上传单个图片（自动把 base64 变成 File 给接口）
export async function fullUploadImages(fileOrBase64) {
	try {
		let file = fileOrBase64

		// ✅ 关键：如果是 base64，自动转成 File 对象（和手动上传一样）
		if (typeof fileOrBase64 === 'string' && fileOrBase64.startsWith('data:image')) {
			file = dataURLToFile(fileOrBase64, "icon.png")
		}

		const ossData = await getUploadParam('', '', "adminIcon")
		const realUrl = await uploadToOss(file, ossData) // 现在接口拿到的是完整 File
		return realUrl
	} catch (err) {
		console.error('上传失败', err)
		throw err
	}
}

// 递归遍历 config，把所有 base64 图标批量上传并替换成 URL
export async function uploadAllIcons(obj) {
	if (!obj) return obj

	// 底部菜单数组
	if (Array.isArray(obj)) {
		for (let item of obj) {
			await uploadAllIcons(item)
		}
		return obj
	}

	// 对象遍历
	for (let key in obj) {
		const val = obj[key]
		if (typeof val === 'string' && val.startsWith('data:image/')) {
			// 是 base64 图片 → 上传
			obj[key] = await fullUploadImages(val)
		} else if (typeof val === 'object' && val !== null) {
			await uploadAllIcons(val)
		}
	}
	return obj
}

//获取html上传密钥
export async function CustomHtmlUploadParam(courseClassId) {
	try {
		const res = await API.get(API.fileurl.getCustomHtmlUploadParam, {
			orgId: localStorage.getItem('orgId') || '',
			courseClassId: courseClassId || '',
			userType: localStorage.getItem('userType'),
			userId: localStorage.getItem('userId'),
		})
		return res.data
	} catch (error) {
		console.error('获取上传凭证失败：', error)
		Message.error('获取上传参数失败')
		throw error
	}
}
export async function HtmlToOss(file, typeId, courseClassId) {
	//执行请求地址

	const fileraw = file
	let url = ''
	var name = file.name
	var size = file.size

	try {
		const ossData = await CustomHtmlUploadParam(courseClassId)
		//执行上传服务器
		url = `${ossData.dir}${ossData.uuid}.html`
		const realUrl = await htmlUploadToOss(fileraw, ossData)
		//执行数据写入数据库并且返回数据库地址
		const htmlIN = await htmlForMysql(name, size, url, courseClassId)
		// 2026-07-17 HTML upload record: keep old string return and expose record id for config rendering.
		const htmlUploadRecordId = getHtmlUploadRecordIdFromResult(htmlIN)
		HtmlToOss.lastHtmlUploadRecordId = htmlUploadRecordId
		HtmlToOss.lastResult = {
			url,
			htmlUploadRecordId
		}
		if (htmlIN) {
			return url
		} else {
			return ''
		}
	} catch (err) {
		return ''
	}

}

function getHtmlUploadRecordIdFromResult(result) {
	if (!result) return ''
	if (typeof result === 'number' || typeof result === 'string') return result
	const data = result.data !== undefined ? result.data : result
	if (typeof data === 'number' || typeof data === 'string') return data
	if (!data || typeof data !== 'object') return ''
	if (data.id !== undefined) return data.id
	if (data.htmlUploadRecordId !== undefined) return data.htmlUploadRecordId
	if (data.htmlId !== undefined) return data.htmlId
	if (data.recordId !== undefined) return data.recordId
	return ''
}
export async function htmlForMysql(name, size, url, courseClassId) {
	try {
		const postHtml = await API.post(API.fileurl.postHtmlSave, {
			name: name,
			size: size,
			url: url,
			aiStandardModelId: courseClassId,
			orgId: localStorage.getItem('orgId'),
			userId: localStorage.getItem('userId'),
			userType: localStorage.getItem('userType'),
			typeId: 1
		})
		return postHtml && postHtml.data && postHtml.data.data !== undefined ? postHtml.data.data : true
	} catch (err) {
		console.log('err', err)
		return false
	}

}
export async function htmlUploadToOss(fileraw, ossData) {
	console.log('fileraw', fileraw)
	if (!fileraw || !ossData) throw new Error('file / ossData 不能为空')
	if (!ossData.host || !ossData.dir || !ossData.uuid) throw new Error('OSS 参数缺失')

	// 处理路径
	const host = ossData.host.replace(/\/$/, '')
	const dir = ossData.dir.replace(/^\//, '').replace(/\/$/, '') + '/'
	const ext = fileraw.name.split('.').pop().toLowerCase() || 'html'
	const key = `${dir}${ossData.uuid}.${ext}`

	const formData = new FormData()
	formData.append('key', key)
	formData.append('OSSAccessKeyId', ossData.accessKeyId)
	formData.append('policy', ossData.policy)
	formData.append('signature', ossData.signature)
	formData.append('file', fileraw)

	try {
		const controller = new AbortController()
		const timer = setTimeout(() => controller.abort(), 30000)

		const res = await fetch(host, {
			method: 'POST',
			body: formData,
			signal: controller.signal
		})

		clearTimeout(timer)

		if (res.status === 200 || res.status === 204) {
			const url = `${host}/${key}`
			console.log('✅ 上传成功：', url)
			return url
		}

		const errMsg = await res.text()
		console.error('❌ OSS 报错：', res.status, errMsg)
		throw new Error(`上传失败 ${res.status}`)
	} catch (err) {
		console.error('❌ 上传异常：', err)
		const msg = err.name === 'AbortError' ? '上传超时' : err.message
		throw new Error('上传失败：' + msg)
	}
}
export function injectCubePostMessage(rawHtml) {
	const injectCode = `
      (function lightHijack() {
          // ========== 稳定索引分配器 ==========
          // 规则：内容特征（id/name/data/全文本/placeholder/type/class）
          //       + 结构路径 sp（层级 + 同标签顺序 + 类型）压尾 → 指纹全局唯一。
          // 动态生成：fpToIdx/nextIdx 持久在闭包，assignAll 多次调用不重置，
          //           新增元素只领新号，老元素编号不漂移；页面刷新按字典序确定性重建。
          const StableIndex = (function () {
              const INDEX_ATTR = 'data-stable-index';

              // 结构路径：从 body 到该元素的 标签[同标签兄弟序号] 链。
              // 任意两个元素不可能层级+顺序+类型完全相同 → 该段保证指纹唯一。
              function structPath(el) {
                  const segs = [];
                  let cur = el;
                  while (cur && cur.nodeType === 1 && cur !== document.body) {
                      let idx = 0;
                      let sib = cur.previousElementSibling;
                      while (sib) {
                          if (sib.tagName === cur.tagName) idx++;
                          sib = sib.previousElementSibling;
                      }
                      segs.unshift(cur.tagName.toLowerCase() + '[' + idx + ']');
                      cur = cur.parentElement;
                  }
                  return 'sp:' + segs.join('/');
              }

              // 计算元素稳定指纹（内容特征 + 结构路径）
              function computeFingerprint(el) {
                  if (!el || el.nodeType !== 1) return '';

                  const parts = [];
                  parts.push(el.tagName.toLowerCase());

                  // 1. id（最稳定；id 也仍带结构路径压尾，防同 id 违规重复）
                  if (el.id) {
                      parts.push('id:' + el.id);
                      return parts.join('|') + '|' + structPath(el);
                  }

                  // 2. name
                  if (el.name) {
                      parts.push('name:' + el.name);
                  }

                  // 3. data 属性（原规则保留：表单全保留；非表单剔除疑似位置索引类）
                  const semanticData = [];
                  const isFormEl = el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.tagName === 'SELECT';
                  if (el.dataset) {
                      for (const key in el.dataset) {
                          const val = el.dataset[key];
                          if (!val) continue;
                          if (key === 'stableIndex') continue;   // 剔除本分配器自己写的属性，防自污染
                          if (isFormEl) {
                              semanticData.push(key + '=' + val);
                          } else {
                              const isLikelyIndex = /^(index|num|order|pos|position|i)$/i.test(key) ||
                                  (/^\\d+$/.test(val) && val.length <= 4);
                              if (!isLikelyIndex) {
                                  semanticData.push(key + '=' + val);
                              }
                          }
                      }
                  }
                  if (semanticData.length > 0) {
                      parts.push('data:' + semanticData.join(','));
                  }

                  // 4. 文本内容（长度不管：全文参与，空白归一保证跨分配一致）
                  const text = (el.innerText || el.textContent || '').trim().replace(/\\s+/g, ' ');
                  if (text && text.length > 0) {
                      parts.push('text:' + text);
                  }

                  // 5. placeholder + type
                  if (el.placeholder) {
                      parts.push('placeholder:' + el.placeholder);
                  }
                  if (el.type) {
                      parts.push('type:' + el.type);
                  }

                  // 6. className 兜底
                  if (el.className && typeof el.className === 'string') {
                      const cls = el.className.trim().split(/\\s+/).filter(Boolean).slice(0, 3).join(',');
                      if (cls) parts.push('cls:' + cls);
                  }

                  // 7. 结构路径压尾（替代原“父元素指纹”递归：父链文本聚合已被移除，
                  //    避免祖先内容一变、全树跟着换号；层级/顺序/类型由 sp 承担）
                  parts.push(structPath(el));

                  return parts.join('|');
              }

              // 持久分配缓存：跨多次 assignAll 不重置 → 动态新增只领新号，老元素保号
              const fpToIdx = new Map();
              let nextIdx = 0;

              // 收集body下所有元素 → 按指纹字典序排序 → 依次分配（已见过的复用旧号）
              function assignAll() {
                  if (!document.body) return;
                  const allEls = document.body.querySelectorAll('*');
                  const list = [];
                  for (let i = 0; i < allEls.length; i++) {
                      const el = allEls[i];
                      // 跳过script、style、meta等无意义元素
                      if (el.tagName === 'SCRIPT' || el.tagName === 'STYLE' || el.tagName === 'NOSCRIPT') continue;
                      const fp = computeFingerprint(el);
                      if (fp) {
                          list.push({ el: el, fp: fp });
                      }
                  }
                  // 按指纹字典序排序——保证跨页面刷新index一致的关键
                  list.sort(function (a, b) {
                      if (a.fp < b.fp) return -1;
                      if (a.fp > b.fp) return 1;
                      return 0;
                  });
                  for (let i = 0; i < list.length; i++) {
                      const item = list[i];
                      let idx = fpToIdx.get(item.fp);
                      if (idx === undefined) {
                          idx = nextIdx++;              // 新指纹：领新号
                          fpToIdx.set(item.fp, idx);
                      }
                      try {
                          item.el.setAttribute(INDEX_ATTR, idx);
                      } catch (e) { /* 忽略 */ }
                  }
              }

              // 防抖重新分配（DOM频繁变化时不会重复计算）
              let reassignTimer = null;
              function scheduleReassign() {
                  if (reassignTimer) clearTimeout(reassignTimer);
                  reassignTimer = setTimeout(function () {
                      reassignTimer = null;
                      assignAll();
                  }, 100);
              }

              // 获取单个元素的index（已分配则直接读属性）
              function getIndex(el) {
                  if (!el || el.nodeType !== 1) return -1;
                  const val = el.getAttribute(INDEX_ATTR);
                  return val !== null ? parseInt(val, 10) : -1;
              }

              return { assignAll, scheduleReassign, getIndex, INDEX_ATTR };
          })();

          // ========== 初始化 ==========
          function initStableIndex() {
              // 首次全量分配
              StableIndex.assignAll();
              // 监听DOM变化：动态生成的元素（renderGrid重建、shuffle等）触发重新分配
              // 重新分配时按指纹排序，同一元素index保持不变
              const observer = new MutationObserver(function () {
                  StableIndex.scheduleReassign();
              });
              observer.observe(document.body, { childList: true, subtree: true });
          }

          // 待上报元素标记，防止重复change触发重复上报
          const pendingChangeElements = new WeakMap();
          function syncTotalToParent() {
              if (!(window.parent && window.parent !== window)) return;
              try {
                  window.parent.postMessage({
                      type: "total_sync",
                      count: typeof targetCount !== "undefined" ? targetCount : 0,
                      max: typeof MAX_CUBES !== "undefined" ? MAX_CUBES : 0,
                      time: Date.now()
                  }, "*");
              } catch (e) {
                  console.warn("[inject] syncTotalToParent error", e);
              }
          }
          function sendRecord(fnName, args, triggerElInfo = null) {
              try {
                  if (!(window.parent && window.parent !== window)) return;
                  const data = {
                      type: "func_trigger_record",
                      funcName: fnName,
                      args: safeClone(args),
                      triggerElement: triggerElInfo,
                      timestamp: Date.now()
                  };
                  window.parent.postMessage(data, "*");
              } catch (e) {
                  console.warn("[inject] sendRecord error", e);
              }
          }
          function safeClone(val) {
              try {
                  return JSON.parse(JSON.stringify(val));
              } catch (err) {
                  return String(val);
              }
          }
          function getElementMeta(el) {
              if (!el || !(el instanceof HTMLElement)) return null;
              const attrs = {};
              if(el.attributes) {
                  for(let i = 0; i < el.attributes.length; i++) {
                      const attr = el.attributes[i];
                      attrs[attr.name] = attr.value;
                  }
              }
              return {
                  id: el.id || "",
                  tagName: el.tagName.toLowerCase(),
                  text: (el.innerText || "").trim(),
                  value: el.value !== undefined ? el.value : "",
                  className: el.className || "",
                  type: el.type || "",
                  dataset: {...el.dataset},
                  attrs: attrs,
                  stableIndex: el.getAttribute(StableIndex.INDEX_ATTR) || ""
              };
          }
          function parseOnclick(codeStr) {
              const funcMatch = codeStr.match(/^\\s*([a-zA-Z0-9_]+)\\s*\\(/);
              const argMatch = codeStr.match(/\\((.*?)\\)/);
              let funcName = "";
              let args = [];
              if (funcMatch) funcName = funcMatch[1];
              if (argMatch && argMatch[1].trim()) {
                  const rawArgs = argMatch[1].split(',').map(item => item.trim());
                  args = rawArgs.map(arg => {
                      if (/^\\d+(\\.\\d+)?$/.test(arg)) return Number(arg);
                      if (/^["'].*["']$/.test(arg)) return arg.slice(1, -1);
                      return arg;
                  });
              }
              return { funcName, args };
          }
          document.addEventListener('click', function(e) {
              try {
                  const target = e.target;
                  if(!(target instanceof HTMLElement)) return;
                  if(target.tagName === 'CANVAS') return;
                  const tag = target.tagName;
                  const hasOnclickAttr = target.hasAttribute('onclick');
                  const roleBtn = target.getAttribute('role') === 'button';
                  let isPointerClickable = false;
                  try{
                      const computedCursor = getComputedStyle(target).cursor;
                      isPointerClickable = computedCursor === 'pointer';
                  }catch(err){
                      isPointerClickable = false;
                  }
                  if(!(tag === 'BUTTON' || tag === 'A' || hasOnclickAttr || roleBtn || isPointerClickable)){
                      return;
                  }
                  const elMeta = getElementMeta(target);
                  const onclickCode = target.getAttribute('onclick') || "";
                  const parseResult = parseOnclick(onclickCode);
                  setTimeout(function(){
                      let reportArgs = parseResult.args || [];
                      let reportFuncName = parseResult.funcName || "";
                      if(!reportFuncName) {
                          reportFuncName = "button_toggle";
                          const latestDataState = target.getAttribute('data-state') || "";
                          reportArgs = [latestDataState];
                      }
                      elMeta.value = JSON.stringify(reportArgs);
                      sendRecord(reportFuncName, reportArgs, elMeta);
                  }, 0);
              } catch (err) {
                  console.warn("[inject] click capture error", err);
              }
          }, true);
          // Enter按下：强制失焦
          document.addEventListener('keydown', function(e) {
              try {
                  const target = e.target;
                  if(!target || !["INPUT","TEXTAREA"].includes(target.tagName)) return;
                  if(e.key !== 'Enter' && e.keyCode !== 13) return;
                  setTimeout(()=>{
                      if(!target.isConnected) return;
                      target.blur();
                  },0);
              } catch (err) {
                  console.warn("[inject] keydown error", err);
              }
          }, true);
          // change捕获阶段
          document.addEventListener('change', function(e) {
              try {
                  const target = e.target;
                  if (!target || !["INPUT","TEXTAREA"].includes(target.tagName)) return;
                  if(pendingChangeElements.has(target)) return;
                  pendingChangeElements.set(target, true);
                  const task = (typeof queueMicrotask === 'function') ? queueMicrotask : function(cb){ setTimeout(cb, 0); };
                  task(() => {
                      setTimeout(() => {
                          pendingChangeElements.delete(target);
                          if (!target.isConnected) return;
                          const elMeta = getElementMeta(target);
                          sendRecord("input_change", [target.value], elMeta);
                      }, 0);
                  });
              } catch (err) {
                  console.warn("[inject] change capture error", err);
              }
          }, true);
          window.addEventListener('message', function(event) {
              try {
                  const msg = event.data;
                  console.log('msg', msg);
                  if (msg.type !== "trigger_btn") return;
                  const { funcName, args = [], triggerElement = null, retryCount = 0 } = msg;
          
                  function innerProcess(currentMsg) {
                      const { funcName: f, args: a, triggerElement: te, retryCount: rc } = currentMsg;
                      if (f && window[f] && typeof window[f] === "function") {
                          console.log("[回放][重试]调用全局函数 " + f, a);
                          window[f].apply(window, a);
                          return;
                      }
                      if (rc < 3 && f) {
                          console.log('[回放][重试]函数 ' + f + ' 仍然未就绪，继续重试');
                          setTimeout(() => {
                              innerProcess({ ...currentMsg, retryCount: rc + 1 });
                          }, 100);
                          return;
                      }
          
                      let btnEl = null;
                      if(te){
                          if(te.id){
                              btnEl = document.getElementById(te.id);
                          }
                          // 稳定索引查找（优先级高于文本和dataset.index）
                          if(!btnEl && te.stableIndex !== undefined && te.stableIndex !== ""){
                              btnEl = document.querySelector('[' + StableIndex.INDEX_ATTR + '="' + te.stableIndex + '"]');
                          }
                          if(!btnEl && te.text){
                              const targetText = te.text;
                              const allClickable = document.querySelectorAll('button, div[onclick], span[onclick], [role="button"], .word-item');
                              for(let i = 0; i < allClickable.length; i++){
                                  const el = allClickable[i];
                                  const t = (el.innerText || "").trim();
                                  const st = getComputedStyle(el);
                                  if(t === targetText && st.display !== 'none' && st.visibility !== 'hidden'){
                                      btnEl = el;
                                      break;
                                  }
                              }
                          }
                          if(!btnEl && te.dataset && te.dataset.index !== undefined){
                              btnEl = document.querySelector('[data-index="' + te.dataset.index + '"]');
                          }
                      }
          
                      if(btnEl){
                          console.warn("[回放][重试耗尽]DOM click触发");
                          btnEl.click();
                      }else{
                          console.warn("[回放][重试耗尽]无可用函数名与元素，跳过执行 triggerElement.text=" + (te?.text||''));
                      }
                  }
          
                  if (funcName === "input_change" && triggerElement?.id) {
                      const inputEl = document.getElementById(triggerElement.id);
                      if (inputEl) {
                          inputEl.value = args[0] ?? "";
                          const inputEvt = new InputEvent('input', {
                              bubbles: true,
                              cancelable: true,
                              inputType: 'insertText'
                          });
                          inputEl.dispatchEvent(inputEvt);
                          const changeEvt = new Event('change', {
                              bubbles: true,
                              cancelable: true
                          });
                          inputEl.dispatchEvent(changeEvt);
                      }
                      return;
                  }
          
                  if (funcName && window[funcName] && typeof window[funcName] === "function") {
                      console.log("[回放]直接调用全局函数 " + funcName, args);
                      window[funcName].apply(window, args);
                      return;
                  }
          
                  if (retryCount < 3 && funcName) {
                      console.log("[回放]函数 " + funcName + " 未就绪，准备重试，剩余次数:" + (3 - retryCount));
                      setTimeout(() => {
                          innerProcess({ ...msg, retryCount: retryCount + 1 });
                      }, 100);
                      return;
                  }
          
                  innerProcess(msg);
              } catch (err) {
                  console.warn("[inject] message handler error", err);
              }
          });
          // 安全监听 targetCount
          try {
              if (typeof targetCount !== "undefined") {
                  let targetCountWatch = window.targetCount;
                  Object.defineProperty(window, "targetCount", {
                      get() { return targetCountWatch; },
                      set(val) {
                          if(targetCountWatch !== val) {
                              targetCountWatch = val;
                              syncTotalToParent();
                          }
                      },
                      configurable: true
                  });
              }
          } catch (e) {
              console.warn("[inject] targetCount defineProperty skipped", e);
          }

          // 启动
          function startInit() {
              try {
                  initStableIndex();
                  syncTotalToParent();
              } catch (e) {
                  console.warn("[inject] init error", e);
              }
          }
          if (document.readyState === 'loading') {
              document.addEventListener('DOMContentLoaded', startInit);
          } else {
              startInit();
          }
          window.addEventListener('load', function() {
              // load后再分配一次，确保所有动态元素都被覆盖
              try { StableIndex.assignAll(); } catch(e) {}
              syncTotalToParent();
          });
      })();
      `;
	let html = rawHtml;
    const scriptTag = `<script>${injectCode}</script>`;
    html = html.replace(/<\/body>/i, scriptTag + `</body>`);
	return html;
}
//2025-10-25前处理唯一编码  但是后期验证出现重复
// export function injectCubePostMessage(rawHtml) {
// 	const injectCode = `
//       (function lightHijack() {
//           // ========== 稳定索引分配器 ==========
//           // 核心原理：不按元素出现顺序分配，而是按元素的"稳定指纹"排序后依次分配。
//           // 这样页面刷新、数组打乱后，同一个元素的排序位置不变 → index 不变。
//           const StableIndex = (function () {
//               const INDEX_ATTR = 'data-stable-index';

//               // 计算元素稳定指纹（基于内容/标识，不基于DOM位置）
//               function computeFingerprint(el, depth) {
//                   if (!el || el.nodeType !== 1) return '';
//                   depth = depth || 0;
//                   if (depth > 5) return '';

//                   const parts = [];
//                   parts.push(el.tagName.toLowerCase());

//                   // 1. id（最稳定）
//                   if (el.id) {
//                       parts.push('id:' + el.id);
//                       return parts.join('|');
//                   }

//                   // 2. name
//                   if (el.name) {
//                       parts.push('name:' + el.name);
//                   }

//                   // 3. data 属性
//                   //    表单元素：全部保留（组合起来是唯一身份）
//                   //    其他元素：排除纯位置索引类属性（如data-index），改用文本等稳定特征
//                   const semanticData = [];
//                   const isFormEl = el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.tagName === 'SELECT';
//                   if (el.dataset) {
//                       for (const key in el.dataset) {
//                           const val = el.dataset[key];
//                           if (!val) continue;
//                           if (isFormEl) {
//                               semanticData.push(key + '=' + val);
//                           } else {
//                               const isLikelyIndex = /^(index|num|order|pos|position|i)$/i.test(key) ||
//                                   (/^\\d+$/.test(val) && val.length <= 4);
//                               if (!isLikelyIndex) {
//                                   semanticData.push(key + '=' + val);
//                               }
//                           }
//                       }
//                   }
//                   if (semanticData.length > 0) {
//                       parts.push('data:' + semanticData.join(','));
//                   }

//                   // 4. 文本内容（单词卡片、按钮等的核心稳定特征）
//                   const text = (el.innerText || el.textContent || '').trim();
//                   if (text && text.length > 0 && text.length <= 200) {
//                       parts.push('text:' + text);
//                   }

//                   // 5. placeholder + type
//                   if (el.placeholder) {
//                       parts.push('placeholder:' + el.placeholder);
//                   }
//                   if (el.type) {
//                       parts.push('type:' + el.type);
//                   }

//                   // 6. 父元素指纹（稳定，因为父元素指纹也不基于位置）
//                   if (el.parentElement && depth < 3) {
//                       const parentFp = computeFingerprint(el.parentElement, depth + 1);
//                       if (parentFp) {
//                           parts.push('parent:' + parentFp);
//                       }
//                   }

//                   // 7. className 兜底
//                   if (el.className && typeof el.className === 'string') {
//                       const cls = el.className.trim().split(/\\s+/).filter(Boolean).slice(0, 3).join(',');
//                       if (cls) parts.push('cls:' + cls);
//                   }

//                   return parts.join('|');
//               }

//               // 核心：收集body下所有元素 → 按指纹排序 → 去重后依次分配index
//               // 因为排序规则固定，同一元素无论出现顺序如何，排序位置不变 → index不变
//               function assignAll() {
//                   if (!document.body) return;
//                   const allEls = document.body.querySelectorAll('*');
//                   const list = [];
//                   for (let i = 0; i < allEls.length; i++) {
//                       const el = allEls[i];
//                       // 跳过script、style、meta等无意义元素
//                       if (el.tagName === 'SCRIPT' || el.tagName === 'STYLE' || el.tagName === 'NOSCRIPT') continue;
//                       const fp = computeFingerprint(el);
//                       if (fp) {
//                           list.push({ el: el, fp: fp });
//                       }
//                   }
//                   // 按指纹字典序排序——这是保证跨页面刷新index一致的关键
//                   list.sort(function (a, b) {
//                       if (a.fp < b.fp) return -1;
//                       if (a.fp > b.fp) return 1;
//                       return 0;
//                   });
//                   // 去重分配：相同指纹得到相同index
//                   const fpToIdx = new Map();
//                   let nextIdx = 0;
//                   for (let i = 0; i < list.length; i++) {
//                       const item = list[i];
//                       if (!fpToIdx.has(item.fp)) {
//                           fpToIdx.set(item.fp, nextIdx++);
//                       }
//                       const idx = fpToIdx.get(item.fp);
//                       try {
//                           item.el.setAttribute(INDEX_ATTR, idx);
//                       } catch (e) { /* 忽略 */ }
//                   }
//               }

//               // 防抖重新分配（DOM频繁变化时不会重复计算）
//               let reassignTimer = null;
//               function scheduleReassign() {
//                   if (reassignTimer) clearTimeout(reassignTimer);
//                   reassignTimer = setTimeout(function () {
//                       reassignTimer = null;
//                       assignAll();
//                   }, 100);
//               }

//               // 获取单个元素的index（已分配则直接读属性）
//               function getIndex(el) {
//                   if (!el || el.nodeType !== 1) return -1;
//                   const val = el.getAttribute(INDEX_ATTR);
//                   return val !== null ? parseInt(val, 10) : -1;
//               }

//               return { assignAll, scheduleReassign, getIndex, INDEX_ATTR };
//           })();

//           // ========== 初始化 ==========
//           function initStableIndex() {
//               // 首次全量分配
//               StableIndex.assignAll();
//               // 监听DOM变化：动态生成的元素（renderGrid重建、shuffle等）触发重新分配
//               // 重新分配时按指纹排序，同一元素index保持不变
//               const observer = new MutationObserver(function () {
//                   StableIndex.scheduleReassign();
//               });
//               observer.observe(document.body, { childList: true, subtree: true });
//           }

//           // 待上报元素标记，防止重复change触发重复上报
//           const pendingChangeElements = new WeakMap();
//           function syncTotalToParent() {
//               if (!(window.parent && window.parent !== window)) return;
//               try {
//                   window.parent.postMessage({
//                       type: "total_sync",
//                       count: typeof targetCount !== "undefined" ? targetCount : 0,
//                       max: typeof MAX_CUBES !== "undefined" ? MAX_CUBES : 0,
//                       time: Date.now()
//                   }, "*");
//               } catch (e) {
//                   console.warn("[inject] syncTotalToParent error", e);
//               }
//           }
//           function sendRecord(fnName, args, triggerElInfo = null) {
//               try {
//                   if (!(window.parent && window.parent !== window)) return;
//                   const data = {
//                       type: "func_trigger_record",
//                       funcName: fnName,
//                       args: safeClone(args),
//                       triggerElement: triggerElInfo,
//                       timestamp: Date.now()
//                   };
//                   window.parent.postMessage(data, "*");
//               } catch (e) {
//                   console.warn("[inject] sendRecord error", e);
//               }
//           }
//           function safeClone(val) {
//               try {
//                   return JSON.parse(JSON.stringify(val));
//               } catch (err) {
//                   return String(val);
//               }
//           }
//           function getElementMeta(el) {
//               if (!el || !(el instanceof HTMLElement)) return null;
//               const attrs = {};
//               if(el.attributes) {
//                   for(let i = 0; i < el.attributes.length; i++) {
//                       const attr = el.attributes[i];
//                       attrs[attr.name] = attr.value;
//                   }
//               }
//               return {
//                   id: el.id || "",
//                   tagName: el.tagName.toLowerCase(),
//                   text: (el.innerText || "").trim(),
//                   value: el.value !== undefined ? el.value : "",
//                   className: el.className || "",
//                   type: el.type || "",
//                   dataset: {...el.dataset},
//                   attrs: attrs,
//                   stableIndex: el.getAttribute(StableIndex.INDEX_ATTR) || ""
//               };
//           }
//           function parseOnclick(codeStr) {
//               const funcMatch = codeStr.match(/^\\s*([a-zA-Z0-9_]+)\\s*\\(/);
//               const argMatch = codeStr.match(/\\((.*?)\\)/);
//               let funcName = "";
//               let args = [];
//               if (funcMatch) funcName = funcMatch[1];
//               if (argMatch && argMatch[1].trim()) {
//                   const rawArgs = argMatch[1].split(',').map(item => item.trim());
//                   args = rawArgs.map(arg => {
//                       if (/^\\d+(\\.\\d+)?$/.test(arg)) return Number(arg);
//                       if (/^["'].*["']$/.test(arg)) return arg.slice(1, -1);
//                       return arg;
//                   });
//               }
//               return { funcName, args };
//           }
//           document.addEventListener('click', function(e) {
//               try {
//                   const target = e.target;
//                   if(!(target instanceof HTMLElement)) return;
//                   if(target.tagName === 'CANVAS') return;
//                   const tag = target.tagName;
//                   const hasOnclickAttr = target.hasAttribute('onclick');
//                   const roleBtn = target.getAttribute('role') === 'button';
//                   let isPointerClickable = false;
//                   try{
//                       const computedCursor = getComputedStyle(target).cursor;
//                       isPointerClickable = computedCursor === 'pointer';
//                   }catch(err){
//                       isPointerClickable = false;
//                   }
//                   if(!(tag === 'BUTTON' || tag === 'A' || hasOnclickAttr || roleBtn || isPointerClickable)){
//                       return;
//                   }
//                   const elMeta = getElementMeta(target);
//                   const onclickCode = target.getAttribute('onclick') || "";
//                   const parseResult = parseOnclick(onclickCode);
//                   setTimeout(function(){
//                       let reportArgs = parseResult.args || [];
//                       let reportFuncName = parseResult.funcName || "";
//                       if(!reportFuncName) {
//                           reportFuncName = "button_toggle";
//                           const latestDataState = target.getAttribute('data-state') || "";
//                           reportArgs = [latestDataState];
//                       }
//                       elMeta.value = JSON.stringify(reportArgs);
//                       sendRecord(reportFuncName, reportArgs, elMeta);
//                   }, 0);
//               } catch (err) {
//                   console.warn("[inject] click capture error", err);
//               }
//           }, true);
//           // Enter按下：强制失焦
//           document.addEventListener('keydown', function(e) {
//               try {
//                   const target = e.target;
//                   if(!target || !["INPUT","TEXTAREA"].includes(target.tagName)) return;
//                   if(e.key !== 'Enter' && e.keyCode !== 13) return;
//                   setTimeout(()=>{
//                       if(!target.isConnected) return;
//                       target.blur();
//                   },0);
//               } catch (err) {
//                   console.warn("[inject] keydown error", err);
//               }
//           }, true);
//           // change捕获阶段
//           document.addEventListener('change', function(e) {
//               try {
//                   const target = e.target;
//                   if (!target || !["INPUT","TEXTAREA"].includes(target.tagName)) return;
//                   if(pendingChangeElements.has(target)) return;
//                   pendingChangeElements.set(target, true);
//                   const task = (typeof queueMicrotask === 'function') ? queueMicrotask : function(cb){ setTimeout(cb, 0); };
//                   task(() => {
//                       setTimeout(() => {
//                           pendingChangeElements.delete(target);
//                           if (!target.isConnected) return;
//                           const elMeta = getElementMeta(target);
//                           sendRecord("input_change", [target.value], elMeta);
//                       }, 0);
//                   });
//               } catch (err) {
//                   console.warn("[inject] change capture error", err);
//               }
//           }, true);
//           window.addEventListener('message', function(event) {
//               try {
//                   const msg = event.data;
//                   console.log('msg', msg);
//                   if (msg.type !== "trigger_btn") return;
//                   const { funcName, args = [], triggerElement = null, retryCount = 0 } = msg;
          
//                   function innerProcess(currentMsg) {
//                       const { funcName: f, args: a, triggerElement: te, retryCount: rc } = currentMsg;
//                       if (f && window[f] && typeof window[f] === "function") {
//                           console.log("[回放][重试]调用全局函数 " + f, a);
//                           window[f].apply(window, a);
//                           return;
//                       }
//                       if (rc < 3 && f) {
//                           console.log('[回放][重试]函数 ' + f + ' 仍然未就绪，继续重试');
//                           setTimeout(() => {
//                               innerProcess({ ...currentMsg, retryCount: rc + 1 });
//                           }, 100);
//                           return;
//                       }
          
//                       let btnEl = null;
//                       if(te){
//                           if(te.id){
//                               btnEl = document.getElementById(te.id);
//                           }
//                           // 稳定索引查找（优先级高于文本和dataset.index）
//                           if(!btnEl && te.stableIndex !== undefined && te.stableIndex !== ""){
//                               btnEl = document.querySelector('[' + StableIndex.INDEX_ATTR + '="' + te.stableIndex + '"]');
//                           }
//                           if(!btnEl && te.text){
//                               const targetText = te.text;
//                               const allClickable = document.querySelectorAll('button, div[onclick], span[onclick], [role="button"], .word-item');
//                               for(let i = 0; i < allClickable.length; i++){
//                                   const el = allClickable[i];
//                                   const t = (el.innerText || "").trim();
//                                   const st = getComputedStyle(el);
//                                   if(t === targetText && st.display !== 'none' && st.visibility !== 'hidden'){
//                                       btnEl = el;
//                                       break;
//                                   }
//                               }
//                           }
//                           if(!btnEl && te.dataset && te.dataset.index !== undefined){
//                               btnEl = document.querySelector('[data-index="' + te.dataset.index + '"]');
//                           }
//                       }
          
//                       if(btnEl){
//                           console.warn("[回放][重试耗尽]DOM click触发");
//                           btnEl.click();
//                       }else{
//                           console.warn("[回放][重试耗尽]无可用函数名与元素，跳过执行 triggerElement.text=" + (te?.text||''));
//                       }
//                   }
          
//                   if (funcName === "input_change" && triggerElement?.id) {
//                       const inputEl = document.getElementById(triggerElement.id);
//                       if (inputEl) {
//                           inputEl.value = args[0] ?? "";
//                           const inputEvt = new InputEvent('input', {
//                               bubbles: true,
//                               cancelable: true,
//                               inputType: 'insertText'
//                           });
//                           inputEl.dispatchEvent(inputEvt);
//                           const changeEvt = new Event('change', {
//                               bubbles: true,
//                               cancelable: true
//                           });
//                           inputEl.dispatchEvent(changeEvt);
//                       }
//                       return;
//                   }
          
//                   if (funcName && window[funcName] && typeof window[funcName] === "function") {
//                       console.log("[回放]直接调用全局函数 " + funcName, args);
//                       window[funcName].apply(window, args);
//                       return;
//                   }
          
//                   if (retryCount < 3 && funcName) {
//                       console.log("[回放]函数 " + funcName + " 未就绪，准备重试，剩余次数:" + (3 - retryCount));
//                       setTimeout(() => {
//                           innerProcess({ ...msg, retryCount: retryCount + 1 });
//                       }, 100);
//                       return;
//                   }
          
//                   innerProcess(msg);
//               } catch (err) {
//                   console.warn("[inject] message handler error", err);
//               }
//           });
//           // 安全监听 targetCount
//           try {
//               if (typeof targetCount !== "undefined") {
//                   let targetCountWatch = window.targetCount;
//                   Object.defineProperty(window, "targetCount", {
//                       get() { return targetCountWatch; },
//                       set(val) {
//                           if(targetCountWatch !== val) {
//                               targetCountWatch = val;
//                               syncTotalToParent();
//                           }
//                       },
//                       configurable: true
//                   });
//               }
//           } catch (e) {
//               console.warn("[inject] targetCount defineProperty skipped", e);
//           }

//           // 启动
//           function startInit() {
//               try {
//                   initStableIndex();
//                   syncTotalToParent();
//               } catch (e) {
//                   console.warn("[inject] init error", e);
//               }
//           }
//           if (document.readyState === 'loading') {
//               document.addEventListener('DOMContentLoaded', startInit);
//           } else {
//               startInit();
//           }
//           window.addEventListener('load', function() {
//               // load后再分配一次，确保所有动态元素都被覆盖
//               try { StableIndex.assignAll(); } catch(e) {}
//               syncTotalToParent();
//           });
//       })();
//       `;
// 	let html = rawHtml;
//     const scriptTag = `<script>${injectCode}</script>`;
//     html = html.replace(/<\/body>/i, scriptTag + `</body>`);
// 	return html;
// }




//新注入26.9.13前
// export function injectCubePostMessage(rawHtml) {
// 	const injectCode = `
//       (function lightHijack() {
//           // 待上报元素标记，防止重复change触发重复上报
//           const pendingChangeElements = new WeakMap();
//           function syncTotalToParent() {
//               if (!(window.parent && window.parent !== window)) return;
//               window.parent.postMessage({
//                   type: "total_sync",
//                   count: typeof targetCount !== "undefined" ? targetCount : 0,
//                   max: typeof MAX_CUBES !== "undefined" ? MAX_CUBES : 0,
//                   time: Date.now()
//               }, "*");
//           }
//           function sendRecord(fnName, args, triggerElInfo = null) {
//               try {
//                   if (!(window.parent && window.parent !== window)) return;
//                   const data = {
//                       type: "func_trigger_record",
//                       funcName: fnName,
//                       args: safeClone(args),
//                       triggerElement: triggerElInfo,
//                       timestamp: Date.now()
//                   };
//                   window.parent.postMessage(data, "*");
//               } catch (e) {
//                   console.warn("[inject] sendRecord error", e);
//               }
//           }
//           function safeClone(val) {
//               try {
//                   return JSON.parse(JSON.stringify(val));
//               } catch (err) {
//                   return String(val);
//               }
//           }
//           function getElementMeta(el) {
//               if (!el || !(el instanceof HTMLElement)) return null;
//               // 收集全部html属性，包含自定义非data-*属性
//               const attrs = {};
//               if(el.attributes) {
//                   for(let i = 0; i < el.attributes.length; i++) {
//                       const attr = el.attributes[i];
//                       attrs[attr.name] = attr.value;
//                   }
//               }
//               return {
//                   id: el.id || "",
//                   tagName: el.tagName.toLowerCase(),
//                   text: (el.innerText || "").trim(),
//                   value: el.value !== undefined ? el.value : "",
//                   className: el.className || "",
//                   type: el.type || "",
//                   dataset: {...el.dataset},
//                   attrs: attrs // 全部原始属性集合
//               };
//           }
//           function parseOnclick(codeStr) {
//               const funcMatch = codeStr.match(/^\\s*([a-zA-Z0-9_]+)\\s*\\(/);
//               const argMatch = codeStr.match(/\\((.*?)\\)/);
//               let funcName = "";
//               let args = [];
//               if (funcMatch) funcName = funcMatch[1];
//               if (argMatch && argMatch[1].trim()) {
//                   const rawArgs = argMatch[1].split(',').map(item => item.trim());
//                   args = rawArgs.map(arg => {
//                       if (/^\\d+(\\.\\d+)?$/.test(arg)) return Number(arg);
//                       if (/^["'].*["']$/.test(arg)) return arg.slice(1, -1);
//                       return arg;
//                   });
//               }
//               return { funcName, args };
//           }
//           document.addEventListener('click', function(e) {
//               try {
//                   const target = e.target;
//                   if(!(target instanceof HTMLElement)) return;
//                   // 直接过滤canvas，three画布交互不做上报
//                   if(target.tagName === 'CANVAS') return;
//                   const tag = target.tagName;
//                   const hasOnclickAttr = target.hasAttribute('onclick');
//                   const roleBtn = target.getAttribute('role') === 'button';
//                   let isPointerClickable = false;
//                   try{
//                       const computedCursor = getComputedStyle(target).cursor;
//                       isPointerClickable = computedCursor === 'pointer';
//                   }catch(err){
//                       isPointerClickable = false;
//                   }
//                   if(!(tag === 'BUTTON' || tag === 'A' || hasOnclickAttr || roleBtn || isPointerClickable)){
//                       return;
//                   }
//                   const elMeta = getElementMeta(target);
//                   const onclickCode = target.getAttribute('onclick') || "";
//                   const parseResult = parseOnclick(onclickCode);
//                   setTimeout(function(){
//                       let reportArgs = parseResult.args || [];
//                       let reportFuncName = parseResult.funcName || "";
//                       if(!reportFuncName) {
//                           reportFuncName = "button_toggle";
//                           const latestDataState = target.getAttribute('data-state') || "";
//                           reportArgs = [latestDataState];
//                       }
//                       elMeta.value = JSON.stringify(reportArgs);
//                       sendRecord(reportFuncName, reportArgs, elMeta);
//                   }, 0);
//               } catch (err) {
//                   console.warn("[inject] click capture error", err);
//               }
//           }, true);
//           // Enter按下：强制失焦
//           document.addEventListener('keydown', function(e) {
//               const target = e.target;
//               if(!["INPUT","TEXTAREA"].includes(target.tagName)) return;
//               if(e.key !== 'Enter' && e.keyCode !== 13) return;
//               setTimeout(()=>{
//                   if(!target.isConnected) return;
//                   target.blur();
//               },0);
//           }, true);
//           // change捕获阶段
//           document.addEventListener('change', function(e) {
//               const target = e.target;
//               if (!["INPUT","TEXTAREA"].includes(target.tagName)) return;
//               if(pendingChangeElements.has(target)) return;
//               pendingChangeElements.set(target, true);
//               queueMicrotask(() => {
//                   setTimeout(() => {
//                       pendingChangeElements.delete(target);
//                       if (!target.isConnected) return;
//                       const elMeta = getElementMeta(target);
//                       sendRecord("input_change", [target.value], elMeta);
//                   }, 0);
//               });
//           }, true);
//           window.addEventListener('message', function(event) {
//               const msg = event.data;
//               console.log('msg', msg);
//               if (msg.type !== "trigger_btn") return;
//               const { funcName, args = [], triggerElement = null, retryCount = 0 } = msg;
          
//               function innerProcess(currentMsg) {
//                   const { funcName: f, args: a, triggerElement: te, retryCount: rc } = currentMsg;
//                   // 路径1：优先直接调用全局函数，不受DOM布局影响
//                   if (f && window[f] && typeof window[f] === "function") {
//                       console.log("[回放][重试]调用全局函数 " + f, a);
//                       window[f].apply(window, a);
//                       return;
//                   }
//                   // 重试计数
//                   if (rc < 3 && f) {
//                       console.log('[回放][重试]函数 ' + f + ' 仍然未就绪，继续重试');
//                       setTimeout(() => {
//                           innerProcess({ ...currentMsg, retryCount: rc + 1 });
//                       }, 300);
//                       return;
//                   }
          
//                   // 路径2：funcName失效，降级DOM查找，使用上报完整triggerElement元数据
//                   let btnEl = null;
//                   if(te){
//                       // 1.优先id
//                       if(te.id){
//                           btnEl = document.getElementById(te.id);
//                       }
//                       // 2.其次文本匹配（消消乐随机洗牌场景核心，优先于dataset.index）
//                       if(!btnEl && te.text){
//                           const targetText = te.text;
//                           const allClickable = document.querySelectorAll('button, div[onclick], span[onclick], [role="button"], .word-item');
//                           for(let i = 0; i < allClickable.length; i++){
//                               const el = allClickable[i];
//                               const t = (el.innerText || "").trim();
//                               const st = getComputedStyle(el);
//                               if(t === targetText && st.display !== 'none' && st.visibility !== 'hidden'){
//                                   btnEl = el;
//                                   break;
//                               }
//                           }
//                       }
//                       // 3.最后才用dataset.index兜底（页面打乱会失效，最低优先级）
//                       if(!btnEl && te.dataset && te.dataset.index !== undefined){
//                           btnEl = document.querySelector('[data-index="' + te.dataset.index + '"]');
//                       }
//                   }
          
//                   if(btnEl){
//                       console.warn("[回放][重试耗尽]DOM click触发");
//                       btnEl.click();
//                   }else{
//                       console.warn("[回放][重试耗尽]无可用函数名与元素，跳过执行 triggerElement.text=" + (te?.text||''));
//                   }
//               }
          
//               if (funcName === "input_change" && triggerElement?.id) {
//                   const inputEl = document.getElementById(triggerElement.id);
//                   if (inputEl) {
//                       inputEl.value = args[0] ?? "";
//                       const inputEvt = new InputEvent('input', {
//                           bubbles: true,
//                           cancelable: true,
//                           inputType: 'insertText'
//                       });
//                       inputEl.dispatchEvent(inputEvt);
//                       const changeEvt = new Event('change', {
//                           bubbles: true,
//                           cancelable: true
//                       });
//                       inputEl.dispatchEvent(changeEvt);
//                   }
//                   return;
//               }
          
//               // 第一次尝试调用全局函数
//               if (funcName && window[funcName] && typeof window[funcName] === "function") {
//                   console.log("[回放]直接调用全局函数 " + funcName, args);
//                   window[funcName].apply(window, args);
//                   return;
//               }
          
//               // 第一次失败进入重试
//               if (retryCount < 3 && funcName) {
//                   console.log("[回放]函数 " + funcName + " 未就绪，准备重试，剩余次数:" + (3 - retryCount));
//                   setTimeout(() => {
//                       innerProcess({ ...msg, retryCount: retryCount + 1 });
//                   }, 300);
//                   return;
//               }
          
//               // 重试耗尽直接走innerProcess做DOM查找
//               innerProcess(msg);
//           });
//           let targetCountWatch = window.targetCount;
//           Object.defineProperty(window, "targetCount", {
//               get() { return targetCountWatch; },
//               set(val) {
//                   if(targetCountWatch !== val) {
//                       targetCountWatch = val;
//                       syncTotalToParent();
//                   }
//               }
//           });
//           window.addEventListener('load', syncTotalToParent);
//       })();
//       `;
// 	let html = rawHtml;
//     const scriptTag = `<script>${injectCode}</script>`;
//     // 插入到 </body> 之前，保证页面原始JS、CDN脚本全部加载完成后再执行注入
//     html = html.replace(/<\/body>/i, scriptTag + `</body>`);
// 	return html;
// }






//注入html方法
// export function injectCubePostMessage(rawHtml) {
// 	const injectCode = `
//       (function lightHijack() {
//           // 待上报元素标记，防止重复change触发重复上报
//           const pendingChangeElements = new WeakMap();

//           function syncTotalToParent() {
//               if (!(window.parent && window.parent !== window)) return;
//               window.parent.postMessage({
//                   type: "total_sync",
//                   count: typeof targetCount !== "undefined" ? targetCount : 0,
//                   max: typeof MAX_CUBES !== "undefined" ? MAX_CUBES : 0,
//                   time: Date.now()
//               }, "*");
//           }

//           function sendRecord(fnName, args, triggerElInfo = null) {
//               if (!(window.parent && window.parent !== window)) return;
//               const data = {
//                   type: "func_trigger_record",
//                   funcName: fnName,
//                   args: safeClone(args),
//                   triggerElement: triggerElInfo,
//                   timestamp: Date.now()
//               };
//               window.parent.postMessage(data, "*");
//           }

//           function safeClone(val) {
//               try {
//                   return JSON.parse(JSON.stringify(val));
//               } catch (err) {
//                   return String(val);
//               }
//           }

//           function getElementMeta(el) {
//               if (!el || !(el instanceof HTMLElement)) return null;
//               return {
//                   id: el.id || "",
//                   tagName: el.tagName.toLowerCase(),
//                   text: (el.innerText || "").trim(),
//                   value: el.value !== undefined ? el.value : "",
//                   className: el.className || "",
//                   type: el.type || ""
//               };
//           }

//           function parseOnclick(codeStr) {
//               const funcMatch = codeStr.match(/^\\s*([a-zA-Z0-9_]+)\\s*\\(/);
//               const argMatch = codeStr.match(/\\((.*?)\\)/);
//               let funcName = "";
//               let args = [];

//               if (funcMatch) funcName = funcMatch[1];
//               if (argMatch && argMatch[1].trim()) {
//                   const rawArgs = argMatch[1].split(',').map(item => item.trim());
//                   args = rawArgs.map(arg => {
//                       if (/^\\d+(\\.\\d+)?$/.test(arg)) return Number(arg);
//                       if (/^["'].*["']$/.test(arg)) return arg.slice(1, -1);
//                       return arg;
//                   });
//               }
//               return { funcName, args };
//           }

//           document.addEventListener('click', function(e) {
//                         const target = e.target;
//                         if(target.tagName !== 'BUTTON') return;
//                         const elMeta = getElementMeta(target);
//                         const onclickCode = target.getAttribute('onclick') || "";
//                         const parseResult = parseOnclick(onclickCode);

//                         setTimeout(function(){
//                             let reportArgs = parseResult.args || [];
//                             let reportFuncName = parseResult.funcName || "";

//                             if(!reportFuncName) {
//                                 reportFuncName = "button_toggle";
//                                 const latestDataState = target.getAttribute('data-state') || "";
//                                 reportArgs = [latestDataState];
//                             }
//                             elMeta.value = JSON.stringify(reportArgs);
//                             sendRecord(reportFuncName, reportArgs, elMeta);
//                         }, 0);
//                     }, true);

//           // Enter按下：强制失焦，保证一定触发change事件，避免页面不blur导致采集丢失
//           document.addEventListener('keydown', function(e) {
//               const target = e.target;
//               if(!["INPUT","TEXTAREA"].includes(target.tagName)) return;
//               if(e.key !== 'Enter' && e.keyCode !== 13) return;
//               setTimeout(()=>{
//                   if(!target.isConnected) return;
//                   target.blur();
//               },0);
//           }, true);

//           // change捕获阶段：仅打标记，不读值；等待页面自身change回调全部执行完毕再上报
//           document.addEventListener('change', function(e) {
//               const target = e.target;
//               if (!["INPUT","TEXTAREA"].includes(target.tagName)) return;
//               if(pendingChangeElements.has(target)) return;
//               pendingChangeElements.set(target, true);

//               queueMicrotask(() => {
//                   setTimeout(() => {
//                       pendingChangeElements.delete(target);
//                       if (!target.isConnected) return;
//                       const elMeta = getElementMeta(target);
//                       sendRecord("input_change", [target.value], elMeta);
//                   }, 0);
//               });
//           }, true);

//           window.addEventListener('message', function(event) {
//               const msg = event.data;
//               if (msg.type !== "trigger_btn") return;
//               const { funcName, args = [], targetId = "" } = msg;

//               if (funcName === "input_change" && targetId) {
//                   const inputEl = document.getElementById(targetId);
//                   if (inputEl) {
//                       inputEl.value = args[0] ?? "";
//                       const inputEvt = new InputEvent('input', {
//                           bubbles: true,
//                           cancelable: true,
//                           inputType: 'insertText'
//                       });
//                       inputEl.dispatchEvent(inputEvt);
//                       const changeEvt = new Event('change', {
//                           bubbles: true,
//                           cancelable: true
//                       });
//                       inputEl.dispatchEvent(changeEvt);
//                   }
//                   return;
//               }

//               if (funcName && window[funcName] && typeof window[funcName] === "function") {
//                   window[funcName].apply(window, args);
//                   return;
//               }

//               if (targetId) {
//                   const btnEl = document.getElementById(targetId);
//                   if (btnEl) btnEl.click();
//                   return;
//               }
//               console.warn("[回放] 无可用函数名与元素ID，跳过执行");
//           });

//           let targetCountWatch = window.targetCount;
//           Object.defineProperty(window, "targetCount", {
//               get() { return targetCountWatch; },
//               set(val) {
//                   if(targetCountWatch !== val) {
//                       targetCountWatch = val;
//                       syncTotalToParent();
//                   }
//               }
//           });

//           window.addEventListener('load', syncTotalToParent);
//       })();
//       `;
// 	let html = rawHtml;
// 	html = html.replace(/<script(?![\s\S]*src=)(?![\s\S]*type=)>/, `<script>${injectCode}`);
// 	return html;
// }





//模型图片上传
export async function ModelUploadParam(blobUrl, submitData, type) {
	const blobToFile = async (blobUrl, filename) => {
		const res = await fetch(blobUrl)
		const blob = await res.blob()
		const file = new File([blob], filename, {
			type: blob.type
		})
		URL.revokeObjectURL(blobUrl)
		return file
	}
	try {
		const fileName = `model_img_${Date.now()}.png`
		console.log('执行fileName', fileName)
		const file = await blobToFile(blobUrl, fileName)
		console.log('file', file)
		const ossData = await ModelUpload(submitData.id)
		console.log('ossData', ossData)
		//执行上传服务器
		let url = `${ossData.dir}${ossData.uuid}.png`
		console.log('url', url)
		const realUrl = await uploadToOss(file, ossData)
		console.log('realUrl', realUrl)
		const isMsy = await postModelResourceAdd(submitData, type, url)
		//执行数据写入数据库并且返回数据库地址
		if (isMsy) {
			return true
		} else {
			return false
		}
	} catch (err) {
		return false
	}

}
export async function postModelResourceAdd(submitData, type, url) {
	try {
		await API.post(API.admin.postModelResourceAdd, {
			aiStandardModelId: submitData.id,
			type: type,
			src: url
		})
		return true
	} catch (error) {
		return false
	}
}
export async function ModelUpload(modelId) {
	try {
		const res = await API.get(API.fileurl.getModelUploadParam, {
			orgId: localStorage.getItem('orgId') || '',
			modelId: modelId || '',
			userId: localStorage.getItem('userId'),
			userType: localStorage.getItem('userType')
		})
		return res.data
	} catch (error) {
		console.error('获取上传凭证失败：', error)
		Message.error('获取上传参数失败')
		throw error
	}
}